<div>
  @if (filteredGoals().length === 0) {
    <div class="modal-panel">
      <span>{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
      @if (hasNoIncentives()) {
        <span>{{ 'flipto.account.CanNotAddGoalsBecausePropertyHasNoIncentives' | translate }}</span>
      }
    </div>
  }

  @for (goal of filteredGoals(); track goal) {
    <div class="modal-panel" [class.disabled]="!goal.isActive">
      <div class="modal-panel-actions">
        <a class="action btn-delete-item" (click)="remove(goal)"></a>
      </div>
      <div class="modal-panel-status"></div>

      <ft-goal-selector-ng [goal]="goal" [types]="types()" />
      <ft-incentive-selector-ng [goal]="goal" [incentives]="filteredByTagIncentives()" [culture]="culture()" />
    </div>
  }

  <div class="modal-footer-align">
    <a class="ft-btn ft-btn-plus-1 ft-btn-outline-light" [class.disabled]="hasNoIncentives()" (click)="addNewGoal()">
      {{ 'flipto.components.goals.AddGoal' | translate }}
    </a>
  </div>
</div>
